export default [
  {
    path: "/e-commerce",
    name: "e-commerce",
    label: "E-commerce",
    component: () => import("@/components/e-commerce/MenuECommerce.vue"),
  },
  {
    path: "/e-commerce/vendas/nuvemshop/status-pedidos",
    name: "e-commerce.vendas.nuvemshop.status-pedidos",
    label: "Status Vendas",
    component: () => import("@/components/e-commerce/views/NuvemshopStatusPedidos.vue"),
  },
  {
    path: "/e-commerce/configuracoes",
    name: "e-commerce.configuracoes",
    label: "Configurações",
    component: () => import("@/components/e-commerce/SubmenuECommerceConfiguracoes.vue"),
  },
  {
    path: "/e-commerce/configuracoes/aliquotas-diretas",
    name: "e-commerce.configuracoes.aliquotas-diretas",
    label: "Ajuste de Alíquotas Diretas",
    component: () => import("@/components/faturamento/configuracoes/aliquotas/mva-aliquota-direta.vue"),
  },
  {
    path: "/e-commerce/configuracoes/fretes",
    name: "e-commerce.configuracoes.fretes",
    label: "Fretes por CEP",
    component: () => import("@/components/e-commerce/fretes/FretesPorCep.vue"),
  },
  {
    path: "/e-commerce/simuladores",
    name: "e-commerce.simuladores",
    label: "Simuladores",
    component: () => import("@/components/e-commerce/simuladores/ListaSimuladores.vue"),
  },
  {
    path: "/e-commerce/simuladores/:codigo/abrir",
    name: "e-commerce.simuladores.abrir",
    label: "Abrir Simulador",
    component: () => import("@/components/e-commerce/simuladores/SimuladorCamisetas.vue"),
  },
  {
    path: "/e-commerce/simuladores/:codigo/configuracoes",
    name: "e-commerce.simuladores.configuracoes",
    label: "Configurações do Simulador",
    component: () => import("@/components/e-commerce/simuladores/ConfiguracoesSimulador.vue"),
  },
];
